import CustomButton from "Components/Custom/CustomButton";
import CustomInput from "Components/Custom/CustomInput";
import { useFormik } from "formik";
import React from "react";
import { FormFeedback,  Modal, ModalBody, ModalHeader } from "reactstrap";
import * as Yup from "yup";

interface TaxModalProps {
  openTaxModal: boolean;
  toggleTaxModal: () => void;

  taxPercentage: number; // Current tax value (like discountPercentage)
  rateOptions: { label: string; value: number }[] | undefined;

  addTax: (percentage: number) => void;
}

interface TaxType {
  taxPercentage: number;
}

const TaxModal: React.FC<TaxModalProps> = ({
  openTaxModal,
  toggleTaxModal,

  taxPercentage,
  rateOptions,
  addTax,
}) => {
  const validation = useFormik<TaxType>({
    enableReinitialize: true,
    initialValues: {
      taxPercentage: taxPercentage,
    },
    validationSchema: Yup.object({
      taxPercentage: Yup.number().required("Tax rate is required"),
    }),
    onSubmit: (values) => {
      addTax(values.taxPercentage);
      validation.resetForm();
    },
  });

  return (
    <Modal
      isOpen={openTaxModal}
      toggle={toggleTaxModal}
      centered
      contentClassName="br-8"
    >
      <ModalHeader className="bg-greyF5 p-3 bg-light" toggle={toggleTaxModal}>
        Select VAT / Tax Rate
      </ModalHeader>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
        }}
        className="h-100 d-flex flex-column justify-content-between"
      >
        <ModalBody className="p-3">
          <div>
            <CustomInput
              type="select"
              placeholder="Select VAT Rate"
              name="taxPercentage"
              label=""
              value={validation.values.taxPercentage}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              touched={validation.touched.taxPercentage}
              error={validation.errors.taxPercentage}
              dropdownOptions={rateOptions}
            />

            {validation.touched.taxPercentage &&
              validation.errors.taxPercentage && (
                <FormFeedback className="d-block">
                  {validation.errors.taxPercentage}
                </FormFeedback>
              )}
          </div>

          <div className="d-flex align-items-start justify-content-between w-100 pt-4 mt-4 border-top border-top-dashed">
            <CustomButton
              type="submit"
              text="Apply Tax"
              className="bg-primary br-7"
            />
          </div>
        </ModalBody>
      </form>
    </Modal>
  );
};

export default TaxModal;
